import {shiftLocalTimestampToUTC} from "@/helpers/date";

export default {
    methods: {
        form_payload_getDateUtcMilliseconds(localDateTimeMilliseconds) {

            return localDateTimeMilliseconds
                ? shiftLocalTimestampToUTC(parseInt(localDateTimeMilliseconds))
                : localDateTimeMilliseconds;
        }
    }
}